module.exports = {
    container: {
        center: true,
        padding: "15px",
    },
    extend: {
        screens: {
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1330px",
            "2xl": "1330px",
            "lg-down": {
                max: "1329px",
            },
            "md-down": {
                max: "1023px",
            },
            "sm-down": {
                max: "767px",
            },
            "sm-only": {
                max: "669px",
            },
        },
        fontFamily: {
            sans: ["Catamaran", "Montserrat", "arial", "sans-serif"],
            heading: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
            daysone: ["DaysOne", "Trebuchet MS", "Helvetica", "sans-serif"],
            catamaran: ["Catamaran", "Montserrat", "arial", "sans-serif"],
        },
        colors: {
            transparent: "transparent",
            current: "currentColor",
            "body-background": "#ffffff",
            'body-text': '#333333',
            "black": {
                DEFAULT: "#000000",
            },
            "white": {
                DEFAULT: "#ffffff",
            },
            primary: {
                DEFAULT: "#031A89",
                50: "#818DC4",
                100: "#ACBAFD",
                200: "#8499FC",
                300: "#5D78FB",
                400: "#3557FB",
                500: "#0D35FA",
                600: "#0529D9",
                700: "#0422B1",
                800: "#031A89",
                900: "#021052",
                950: "#010A37",
                hover: "#818DC4",
            },
            secondary: {
                DEFAULT: "#812C97",
                50: "#E1C4E9",
                100: "#F5E8F8",
                200: "#E7C9EF",
                300: "#D9A9E6",
                400: "#CC89DD",
                500: "#BE6AD4",
                600: "#B04ACA",
                700: "#9C35B7",
                800: "#812C97",
                900: "#5C1F6C",
                950: "#491956",
                hover: "#E1C4E9",
            },
            accent: {
                DEFAULT: "#1DA5AB",
                light: '#E8F6F7',
                50: "#C3EEEF",
                100: "#EAFBFB",
                200: "#DEF2F3",
                300: "#A4ECF0",
                400: "#81E5EA",
                500: "#5FDEE4",
                600: "#3CD7DE",
                700: "#23C7CE",
                800: "#1DA5AB",
                900: "#15777B",
                950: "#116063",
                hover: "#C3EEEF",
            },
            blue: {
                DEFAULT: "#031A89",
                50: "#C0CBFE",
                100: "#ACBAFD",
                200: "#8499FC",
                300: "#5D78FB",
                400: "#3557FB",
                500: "#0D35FA",
                600: "#0529D9",
                700: "#0422B1",
                800: "#031A89",
                900: "#021052",
                950: "#010A37",
            },
            purple: {
                DEFAULT: "#812C97",
                50: "#FCF8FD",
                100: "#F5E8F8",
                200: "#E7C9EF",
                300: "#D9A9E6",
                400: "#CC89DD",
                500: "#BE6AD4",
                600: "#B04ACA",
                700: "#9C35B7",
                800: "#812C97",
                900: "#5C1F6C",
                950: "#491956",
            },
            light: "#D9EDEE",
        },
        lineHeight: {
            'heading': '1.27',
        },
        margin: {
            container: "15px",
        },
        borderRadius: {
            button: "23px",
        },
        boxShadow: {
            card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
            callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
        },
    },
};